import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
  DataService,
  IPersistable,
  PersistenceService,
  PersistMode,
  ReadPicklistItemsModel,
} from '@barthauer/abc/core/data';
import { ResourceManager } from '@barthauer/abc/core/resources';
import {
  AbcComboboxComponent,
  AbcDatepickerComponent,
  AbcInputComponent,
  AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DocInfo, DocumentModel } from '../../../models/document.model';
import { DocumentsEditorsService } from '../../../services/documents-editors.service';
import { ValueWrapper, ValueWrapperViewModel } from '../../../services/valueWrapper';

@Component({
  selector: 'test-app-documents-editor-card-details',
  templateUrl: './documents-editor-card-details.component.html',
  styleUrls: ['./documents-editor-card-details.component.scss'],
})
export class DocumentsEditorCardDetailsComponent implements OnInit {
  @ViewChild('designationInput', { static: true }) designationInput: AbcInputComponent;
  @ViewChild('dateInput', { static: true }) dateInput: AbcDatepickerComponent;
  @ViewChild('numberInput', { static: true }) numberInput: AbcInputComponent;
  @ViewChild('programPathInput', { static: true }) programPathInput: AbcInputComponent;
  @ViewChild('fileNameUploader', { static: true }) fileNameUploader: AbcInputComponent;
  @ViewChild('validFromInput', { static: true }) validFromInput: AbcDatepickerComponent;
  @ViewChild('validUntilInput', { static: true }) validUntilInput: AbcDatepickerComponent;
  @ViewChild('Comment', { static: true }) Comment: AbcTextAreaComponent;
  @ViewChild('abc', { static: true, read: ViewContainerRef }) abc: ViewContainerRef;
  @ViewChild('dataCarrierCombobox', { static: true }) dataCarrierCombobox: AbcComboboxComponent;
  @ViewChild('documentKindCombobox', { static: true }) documentKindCombobox: AbcComboboxComponent;
  objectKey;
  private listOfValueWrappers = {};
  private componentContainer = [];
  private documentKindData: any;
  private documentCarrierData: any;
  private unsubscribe$ = new Subject<void>();
  public document: DocumentModel;
  public displayDetailsFields: boolean;
  public isOkBtnDisabled: boolean = true;
  private newFile: DocInfo;
  private fileToUpload: any;
  private persistable: IPersistable
  @Input() private _docInfo;
  public get docInfo() {
    return this._docInfo;
  }
  public res = ResourceManager.getResources('abc-common-editors-documents');
  public filename: string = '';
  public set docInfo(value) {
    this.displayDetailsFields = true;
    if (value) {
      this.document = value;
      this.objectKey.id = value.Id;
      if (this.document?.Id) {
        this.addObjectForMerge();
      }
      this.fillFields(value);
    } else {
      this.displayDetailsFields = false;
    }
  }

  constructor(
    private persistenceService: PersistenceService,
    private dataService: DataService,
    private documentsEditorsService: DocumentsEditorsService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.objectKey = new ValueWrapperViewModel(this.persistenceService);
    this.queryPicklistItems('Dokumentart')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.documentKindData = result.Data;
      });

    this.queryPicklistItems('Bildspeichermedium')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.documentCarrierData = result.Data;
      });
    this.componentContainer.push(
      this.designationInput,
      this.dateInput,
      this.fileNameUploader,
      this.documentKindCombobox,
      this.dataCarrierCombobox,
      this.numberInput,
      this.programPathInput,
      this.validFromInput,
      this.validUntilInput,
      this.Comment
    );
    this.objectKey.objectType = 'Document';
  }

  ngAfterViewInit(): void {    
    this.designationInput.onChange.subscribe((result) => {
      if (this.listOfValueWrappers[this.designationInput.id]) {
        this.persistenceService.addObjectValue(
          this.persistable,
          this.designationInput.id,
          result.newValue,
          this.listOfValueWrappers[this.designationInput.id]?.value
        );
        this.listOfValueWrappers[this.designationInput.id].value = result.newValue;
      }
      this.isOkBtnDisabled = result.newValue ? false : true;
      this.changeDetectorRef.detectChanges();
    });
    this.dateInput.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
        this.persistable,
        this.dateInput.id,
        result.newValue,
        this.listOfValueWrappers[this.dateInput.id]?.value
      );
      this.listOfValueWrappers[this.dateInput.id].value = result.newValue;
    });
    this.fileNameUploader.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
        this.persistable,
        this.fileNameUploader.id,
        result.newValue,
        this.listOfValueWrappers[this.fileNameUploader.id]?.value
      );
      this.listOfValueWrappers[this.fileNameUploader.id].value = result.newValue;
    });
    this.documentKindCombobox.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
        this.persistable,
        this.documentKindCombobox.id,
        result.newValue,
        this.listOfValueWrappers[this.documentKindCombobox.id]?.value
      );
      this.listOfValueWrappers[this.documentKindCombobox.id].value = result.newValue;
    });
    this.dataCarrierCombobox.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
        this.persistable,
        this.dataCarrierCombobox.id,
        result.newValue,
        this.listOfValueWrappers[this.dataCarrierCombobox.id]?.value
      );
      this.listOfValueWrappers[this.dataCarrierCombobox.id].value = result.newValue;
    });
    this.numberInput.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
        this.persistable,
        this.numberInput.id,
        result.newValue,
        this.listOfValueWrappers[this.numberInput.id]?.value
      );
      this.listOfValueWrappers[this.numberInput.id].value = result.newValue;
    });
    this.programPathInput.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
        this.persistable,
        this.programPathInput.id,
        result.newValue,
        this.listOfValueWrappers[this.programPathInput.id]?.value
      );this.listOfValueWrappers[this.programPathInput.id].value = result.newValue;

    });
    this.validFromInput.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
          this.persistable,
          this.validFromInput.id,
          result.newValue,
          this.listOfValueWrappers[this.validFromInput.id]?.value
        );
        this.listOfValueWrappers[this.validFromInput.id].value = result.newValue;
    });
    this.validUntilInput.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
        this.persistable,
        this.validUntilInput.id,
        result.newValue,
        this.listOfValueWrappers[this.validUntilInput.id]?.value
      );
      this.listOfValueWrappers[this.validUntilInput.id].value = result.newValue;
    });
    this.Comment.onChange.subscribe((result) => {
      this.persistenceService.addObjectValue(
        this.persistable,
        this.Comment.id,
        result.newValue,
        this.listOfValueWrappers[this.Comment.id]?.value
      );
      this.listOfValueWrappers[this.Comment.id].value = result.newValue;
    });
    const el = document.querySelector('.dx-fileuploader-button>.dx-button-content');
    el.outerHTML = '<i class="material-icons dx-icon">cloud_upload</i>';
  }

  public cancelButton(): void {
    this.documentsEditorsService.callCloseDialogSubject();
  }

  public okButton(): void {
    this.documentsEditorsService.callUpdateDataSubject(this.fileToUpload);
    this.documentsEditorsService.callPersistPendingChanges();
    this.documentsEditorsService.callCloseDialogSubject();
  }

  public resetButton(): void {
    this.persistenceService.revertPendingChanges();
  }

  public uploadFileData(data): void {
    this.fileToUpload = data;
    this.newFile = new DocInfo(data.docDetails);
    this.designationInput.value = this.newFile.Designation;
    // this.dateInput.value = this.newFile.Date;
    this.dateInput.value = new Date();
    this.documentKindCombobox.value = this.documentsEditorsService.getFileType(this.newFile.Designation);
    this.fileNameUploader.value = this.newFile.FileName;
    this.isOkBtnDisabled = false;
    this.fillListOfValueWrappers(this.newFile);
  }

  private fillFields(data): void {
    this.designationInput.value = data.Designation;
    this.dateInput.value = data.Date;
    this.fileNameUploader.value = data.FileName;
    this.numberInput.value = data.Number;
    this.programPathInput.value = data.ProgramPath;
    this.validFromInput.value = data.ValidFrom;
    this.validUntilInput.value = data.ValidUntil;
    this.Comment.value = data.Comment;
    this.documentKindCombobox.value = this.documentsEditorsService.getFileType(data.Designation);
    this.fillListOfValueWrappers(data);
  }

  public openDocumentKind(): void {
    this.documentKindCombobox.onComboboxOpen(null, this.documentKindData, 'Description');
  }

  public openDocumentCarrier(): void {
    this.dataCarrierCombobox.onComboboxOpen(null, this.documentCarrierData, 'Description');
  }

  private queryPicklistItems(parameter): Observable<any> {
    const observable$ = new Observable((observer) => {
      const queryPicklistItems: ReadPicklistItemsModel = new ReadPicklistItemsModel();
      queryPicklistItems.Indent = true;
      queryPicklistItems.OutputMode = 0;
      queryPicklistItems.Name = parameter;
      this.dataService.executeReadPicklistsItemsQuery(queryPicklistItems).subscribe((result) => {
        observer.next(result);
      });
    });
    return observable$;
  }

  private fillListOfValueWrappers(data): void {
    for (const property in data) {
      this.listOfValueWrappers[property] = new ValueWrapper(
        property,
        data[property],
        this.objectKey,
        this.persistenceService
      );
    }
    this.objectKey.listOfValueWrappers = this.listOfValueWrappers;
    this.objectKey.abcComponentContainer = this.componentContainer;
  }

  private addObjectForMerge() {
    this.persistable = {
      id: this.document.Id,
      objectType: 'Document',
      persistenceCategory: this.documentsEditorsService.persistenceCategory,
      changesPersisted: (persistMode) => (persistMode = PersistMode.Update),
      revertChanges: () => {},
    };
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
